(function() {
    let counterWrapper = document.querySelectorAll('.is-style-counter-wrapper');

    function addAosAttributes() {
        let animatedElems = document.querySelectorAll('.fade-right, .fade-left, .fade-up, .fade-down, .fade-columns');
        let fadeColumnsCounter = 1;

        if (counterWrapper.length) {
            counterWrapper.forEach(function(item, index) {
                item.setAttribute('data-aos', '');
                item.setAttribute('data-aos-id', 'show_counter_' + (index + 1));
            });
        }

        if ( animatedElems.length ) {
            animatedElems.forEach(function(item, index) {

                if (item.classList.contains('fade-right')) {
                    item.setAttribute('data-aos', 'fade-right');
                } else if (item.classList.contains('fade-left')) {
                    item.setAttribute('data-aos', 'fade-left');
                } else if (item.classList.contains('fade-up')) {
                    item.setAttribute('data-aos', 'fade-up');
                } else if (item.classList.contains('fade-down')) {
                    item.setAttribute('data-aos', 'fade-down');
                } else if (item.classList.contains('fade-columns')) {
                    if( item.previousElementSibling) {
                        fadeColumnsCounter++;
                    }
                    item.setAttribute('data-aos', 'fade-up');
                    item.setAttribute('data-aos-delay', 150 * fadeColumnsCounter);

                    if( !item.nextElementSibling ) {
                        fadeColumnsCounter = 1;
                    }
                }

                if (animatedElems.length == (index + 1)) {
                    setTimeout(function() {
                        AOS.init({
                          once: false,
                          duration: 900,
                          offset: 100,
                          once: true,
                          duration: 700,
                          easing: 'ease-out',
                          throttleDelay: 200,
                        //   anchorPlacement: 'bottom-top',
                          offset: 100
                        });

                        // animateCounter();
                    }, 500);
                }
            });
        } else {
            setTimeout(function() {
                AOS.init({
                  throttleDelay: 200,
                  once: false,
                  duration: 900,
                  offset: 100,
                  once: true,
                  duration: 700,
                  easing: 'ease-out',
                //   anchorPlacement: 'bottom-top',
                });

                // animateCounter();
            }, 500);
        }
    }


    function animateCounter(container) {
        const counters = container.getElementsByClassName('counter__number');

        [...counters].forEach(counter => {
            const attr = counter.dataset.counter;
            const value = parseFloat(attr);
            const units = counter.dataset.units ? counter.dataset.units : '';
            const speed = 10;
            const range = Math.ceil(value / speed);
            let count = 0;


            const animation = setInterval(() => startCounter(), 80);

            function startCounter() {
                if (count < value) {
                    count += range;
                    counter.innerHTML = count + units;
                }
                else stopCounter();
            }

            function stopCounter() {
                counter.innerHTML = value + units;
                clearInterval(animation);
            }
        })
    }

    if( counterWrapper.length ) {
        counterWrapper.forEach(function(item, index) {
            document.addEventListener('aos:in:show_counter_' + (index + 1), () => {
                animateCounter(item);
            });
        });
    }


    function sliders() {
        const sliderNames = [
            '.is-style-right-slider',
            '.is-style-letter-slider',
            '.is-style-people-slider',
            '.is-style-single-slider'
        ]
        let elems = document.querySelectorAll(sliderNames);

        if( elems ) {
            elems.forEach(function(elem, index) {

                let count = {};
                if (elem.classList.contains('is-style-right-slider')) {
                    count = {
                        'm'  : 1,
                        'xs' : 2,
                        'sm' : 2,
                        'md' : 2,
                        'lg' : 2,
                    }
                }
                if (elem.classList.contains('is-style-letter-slider')) {
                    count = {
                        'm'  : 1,
                        'xs' : 2,
                        'sm' : 2,
                        'lg' : 3,
                        'lg' : 3
                    }
                }
                if (elem.classList.contains('is-style-people-slider')) {
                    count = {
                        'm'  : 2,
                        'xs' : 2,
                        'sm' : 4,
                        'lg' : 5,
                        'lg' : 6
                    }
                }
                if (elem.classList.contains('is-style-single-slider')) {
                    count = {
                        'm'  : 1,
                        'xs' : 1,
                        'sm' : 1,
                        'lg' : 1,
                        'lg' : 1
                    }
                }
                let autoplay = elem.classList.contains('manual') ? false : true;
                let item = elem.querySelector('.wp-block-group__inner-container');
                var slider = tns({
                  container: item,
                  items: count['m'],
                  slideBy: 1,
                  autoplay: autoplay,
                  autoplayButton: false,
                  autoplayTimeout: 5000,
                  autoplayButtonOutput: false,
                  speed: 600,
                  mode: 'carousel',
                  mouseDrag: true,
                  controls: true,
                  nav: false,
                  controlsPosition: 'bottom',
                  gutter: 0,
                  responsive: {
                    370: {
                        items: count['xs'],
                        center: false,
                    },
                    768: {
                        items: count['sm'],
                    },
                    1023: {
                        items: count['md'],
                    },
                    1336: {
                        items: count['lg'],
                    }
                  }
                });
            });
        }
    }

    function scrollDown() {
        let elem = $(".scroll-down");
        let target = elem.closest('.main').next();
        elem.click(function(e) {
            e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: target.offset().top
            }, 800);
        });
    }

    function scrollToTop() {
        const scroll = document.getElementById('toTop');

        scroll.addEventListener('click', e => {
            e.preventDefault();
            $('html, body').animate({scrollTop: 0}, 'slow');
        })
    }

    function colorbox() {
        $('.gallery-page .wp-block-image a, .blocks-gallery-item a, .lightbox').colorbox({
            rel:'gallery',
            current: "{current}/{total}",
            maxWidth: '90%',
            maxHeight: '90%',
        });
    }


    function datePicker() {
        const dates = document.querySelectorAll('.info__sort input[type="date"]');
        const startDate = document.querySelector('input[name="startDate"]');
        const endDate = document.querySelector('input[name="endDate"]');

        dates.forEach(date => {
            date.addEventListener('change', e => {
                const { name, value } = e.target;

                if (name == 'startDate') {
                    endDate.setAttribute('min', value);
                }
                if (name == 'endDate') {
                    startDate.setAttribute('max', value);
                }
            })
        })
    }


    window.addEventListener('resize', () => sliders);

    window.addEventListener('load', function() {
        scrollDown();
        sliders();
        colorbox();
        addAosAttributes();
        scrollToTop();
        datePicker();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 4
// module chunks = 0